module.exports = __webpack_public_path__ + "static/img/16.eb20b7b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/16.png
// module id = xyFk
// module chunks = 0